import { DateRangeInputBlock } from '@coast/schemas';
import { useCallback, useMemo } from 'react';
import { useCardFormContext } from '@shared/components/blocks/contexts/form';
import { createEndDateInputBlock, createStartDateInputBlock } from './dateRangeInputBlocks';
import { useDateRangeDefaultValues } from './input/hooks';
import { MBCardInputBlockDate } from './inputDate';

interface Props {
  block: DateRangeInputBlock;
}

export function MBCardInputBlockDateRange({ block }: Props) {
  const startDateInputBlock = useMemo(() => createStartDateInputBlock(block), [block]);
  const endDateInputBlock = useMemo(() => createEndDateInputBlock(block), [block]);

  const { values, setFieldValue } = useCardFormContext();
  const startDate = values[startDateInputBlock.name];
  const endDate = values[endDateInputBlock.name];

  const setStartDate = useCallback(
    (value: string) => setFieldValue(startDateInputBlock.name, value),
    [startDateInputBlock.name, setFieldValue],
  );
  const setEndDate = useCallback(
    (value: string) => setFieldValue(endDateInputBlock.name, value),
    [endDateInputBlock.name, setFieldValue],
  );

  useDateRangeDefaultValues(
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    block.delta?.unit ?? 'day',
    block.delta?.count ?? 1,
  );

  return (
    <>
      <MBCardInputBlockDate block={startDateInputBlock} />
      <MBCardInputBlockDate block={endDateInputBlock} />
    </>
  );
}
